import React from 'react';

import "./Error.css";
const Error = () => {
    return (
        <div className="wide">
            <div id="doge">

            </div>
        </div>
    )
}

export default Error
